export * from './fixed-assets-register.action';
export * from './fixed-assets-register.state';
